import React from "react";
import moment from "moment";
import Text from "../../../../Diathrive/src/components/elements/Text";
import Button from "../../../../Diathrive/src/components/elements/Button";
import {
  BUTTON_TYPES,
  COLORS,
} from "../../../../Diathrive/src/utils/Constants";
import styles from "./styles";

const STATUS_BADGE = {
  upcoming: { bg: COLORS.green || "#34C759", label: "Upcoming" },
  past: { bg: COLORS.grey2, label: "Completed" },
  cancelled: { bg: COLORS.red || "#FF3B30", label: "Cancelled" },
};

const WebAppointmentCard = ({ appointment, status = "upcoming" }) => {
  const isUpcoming = status === "upcoming";
  const badge = STATUS_BADGE[status] || STATUS_BADGE.upcoming;

  const onJoin = () => {
    if (appointment.eventType === "Video") {
      window.open(appointment.joinUrl, "_blank");
    } else {
      window.open(`tel:${appointment.oneTapPhoneLink}`, "_blank");
    }
  };

  const onCancel = () => {
    window.open(appointment.cancelUrl, "_blank");
  };

  const onReschedule = () => {
    window.open(appointment.rescheduleUrl, "_blank");
  };

  return (
    <div
      style={{
        ...styles.cardContainer,
        ...(isUpcoming ? {} : styles.pastCard),
      }}
    >
      <div style={styles.cardDetail}>
        <div
          style={{
            ...styles.dateBox,
            ...(isUpcoming ? {} : styles.dateBoxPast),
          }}
        >
          <Text variation="Text1Regular" color={COLORS.white}>
            {moment(appointment.startTime).format("ddd")}
          </Text>
          <Text variation="Headline4Bold" color={COLORS.white}>
            {moment(appointment.startTime).format("DD")}
          </Text>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ ...styles.badge, backgroundColor: badge.bg }}>
            <Text variation="Text2Medium" color={COLORS.white}>
              {badge.label}
            </Text>
          </div>
          <Text
            variation="Body1SemiBold"
            color={COLORS.black}
            topMargin={8}
          >
            {appointment.advisor.firstname +
              " " +
              appointment.advisor.lastname}
          </Text>
          <Text
            variation="Text1Regular"
            color={COLORS.grey2}
            topMargin={8}
          >
            {moment(appointment.startTime).format("MMM D, YYYY • hh:mm A")}
          </Text>
          {isUpcoming && (
            <div style={styles.joinLink} onClick={onJoin}>
              <Text variation="Text1Regular" color={COLORS.grey2}>
                {appointment.eventType === "Video"
                  ? "Join Video Call"
                  : "Join Phone Call"}
              </Text>
            </div>
          )}
        </div>
      </div>
      {isUpcoming && (
        <div style={styles.cardActions}>
          <Button
            style={styles.actionButton}
            buttonType={BUTTON_TYPES.Bordered}
            titleColor={COLORS.mainLargeText}
            title={"Cancel"}
            onPress={onCancel}
          />
          <Button
            style={styles.actionButton}
            buttonType={BUTTON_TYPES.Bordered}
            titleColor={COLORS.mainLargeText}
            title={"Reschedule"}
            onPress={onReschedule}
          />
        </div>
      )}
    </div>
  );
};

export default WebAppointmentCard;
